import { useMutation } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import {
  AutomationProjectionsPayload,
  AutomationProjectionsQuery,
} from '@rossum/api-client/queues';
import { api } from '../../../../../lib/apiClient';

export const useGetCustomProjections = () => {
  return useMutation({
    mutationKey: ['get-custom-projections'],
    mutationFn: ({
      queueId,
      payload,
      query,
    }: {
      queueId: number;
      payload: AutomationProjectionsPayload;
      query: AutomationProjectionsQuery;
    }) => {
      return api.request(
        endpoints.queues.automationProjections(queueId, payload, query)
      );
    },
  });
};
